import React, { Fragment } from 'react';
import { useTranslate } from 'Translate';

export default (props) => {
  const { columns, data } = props;
  const i18n = useTranslate();
    const { t } = i18n;

  return (
    <div className="inventory-table-container">
      <div className="inventory-table">
        <table>
          <thead>
            <tr>
              {columns?.po_summary_listing?.list?.map(item =>
                <th className={`${item?.longCol ? 'long-col' : ''} text-${item.align}`} key={`Title ${item.title}`}>
                  {item.title}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data?.list?.map((listItem, listItemIndex) => 
              <Fragment key={`List Item ${listItemIndex}`}>
                <tr>
                  <td>{listItem.date}</td>
                </tr>
                {listItem?.list?.map((childListItem, childListItemIndex) => 
                  <tr key={`List Item ${childListItemIndex}: Child List Item ${childListItemIndex}`}>
                    <td>{childListItem.reference}</td>
                    <td>{childListItem.status}</td>
                    <td>{childListItem.vendor_code}</td>
                    <td align='right'>{childListItem.qty}</td>
                    <td align='right'>{childListItem.gross_amount}</td>
                    <td align='right'>{childListItem.discount_amount}</td>
                    <td align='right'>{childListItem.tax_amount}</td>
                    <td align='right'>{childListItem.amount}</td>
                    <td align='right'>{childListItem.inv_cost}</td>
                    <td align='right'>{childListItem.received_qty}</td>
                    <td align='right'>{childListItem.outstanding_qty}</td>
                  </tr>
                )}
                <tr className='bg-gray text-white'>
                  <td colSpan={2}></td>
                  <td>{t("Crm.subtotal")}</td>
                  {listItem?.sub_totals?.map((item, index) => 
                    <td key={`Sub Total ${item} ${index}`} align='right'>{item}</td>
                  )}
                </tr>
              </Fragment>
            )}

            
            <tr className='bg-gray text-white'>
              <td colSpan={2}></td>
              <td>{t("SalesReporting.grand_total")}</td>
              {data?.grand_total?.map((item, index) => 
                <td key={`Grand Total ${item} ${index}`} align='right'>{item}</td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}